module.exports = __webpack_public_path__ + "img/user.a6ee991b.png";